import { createSelector } from '@reduxjs/toolkit';
import { weekStart } from './week-start';
import { LocalDate } from '../../../utilities/local-date';
import holidaysList from '../../data/holidays.json';
import { sortBy } from 'lodash';

export const holidays = createSelector(weekStart, (weekStart) => {
  const calStart = LocalDate.fromString(weekStart);
  const calEnd = calStart.plusDays(6);
  let holidays = holidaysList.filter(function (holiday) {
    return (
      LocalDate.fromString(holiday.date).isSameOrAfter(calStart) &&
      LocalDate.fromString(holiday.date).isSameOrBefore(calEnd)
    );
  });
  holidays = sortBy(holidays, (e) => e.date);
  return holidays;
});
